export default function(data) {
var __t, __p = '';
__p += '<div class="icon trash confirm-delete small">Are you sure?\n  <span class="yes-delete link">YES</span>\n  <span class="no-delete link">NO</span>\n</div>\n';
return __p
}